import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'linkify'
})
export class LinkifyPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(text: string): SafeHtml {
    if (!text) return '';

    let formattedText = text;

    // Convert markdown bold (**text**)
    formattedText = formattedText.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

    // Convert markdown italic (*text* or _text_)
    formattedText = formattedText.replace(/(?<!\*)\*(?!\*)(.+?)\*(?!\*)/g, '<em>$1</em>');
    formattedText = formattedText.replace(/_(.+?)_/g, '<em>$1</em>');

    // Convert markdown code (`code`)
    formattedText = formattedText.replace(/`(.+?)`/g, '<code>$1</code>');

    // Convert bullet points (- item or * item)
    formattedText = formattedText.replace(/^[\s]*[-*]\s+(.+)$/gm, '<li>$1</li>');
    
    // Wrap consecutive list items in <ul>
    formattedText = formattedText.replace(/(<li>.*<\/li>\n?)+/g, (match) => {
      return '<ul>' + match + '</ul>';
    });

    // Convert URLs to clickable links
    const urlRegex = /(https?:\/\/[^\s<]+)/g;
    formattedText = formattedText.replace(urlRegex, (url) => {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });

    // Convert newlines to <br>
    formattedText = formattedText.replace(/\n/g, '<br>');

    return this.sanitizer.sanitize(1, formattedText) || '';
  }
}
